var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import i18next from "i18next";
import { login } from "frontend/src/api/auth";
import { viewerSet } from "frontend/src/domain/session/model";
import { locales } from "frontend/src/domain/localization/i18n";
import { Role } from "frontend/src/shared/types/role";
export var usePageModel = function () {
    var _a = __read(React.useState(""), 2), username = _a[0], setUsername = _a[1];
    var _b = __read(React.useState(""), 2), password = _b[0], setPassword = _b[1];
    var _c = __read(React.useState(true), 2), rememberMe = _c[0], setRememberMe = _c[1];
    var _d = __read(React.useState(false), 2), isSubmitting = _d[0], setSubmitting = _d[1];
    var _e = __read(React.useState({}), 2), errors = _e[0], setErrors = _e[1];
    var validate = function () {
        var _a, _b;
        var isValid = true;
        var errors = { username: [], password: [] };
        if (username.length === 0) {
            (_a = errors.username) === null || _a === void 0 ? void 0 : _a.push(i18next.t("errors.emptyField", { ns: locales.namespaces.shared }));
            isValid = false;
        }
        if (password.length === 0) {
            (_b = errors.password) === null || _b === void 0 ? void 0 : _b.push(i18next.t("errors.emptyField", { ns: locales.namespaces.shared }));
            isValid = false;
        }
        if (!isValid) {
            setErrors(errors);
        }
        return isValid;
    };
    var submit = function () {
        setErrors({});
        if (!validate()) {
            return;
        }
        setSubmitting(true);
        login({ username: username, password: password, remember: rememberMe })
            .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (response.type === "failure") {
                            setSubmitting(false);
                            setErrors(response.payload);
                        }
                        if (!(response.type === "success")) return [3 /*break*/, 3];
                        if (!(response.payload.role === Role.Rightholder)) return [3 /*break*/, 2];
                        return [4 /*yield*/, new Promise(function (res) {
                                return i18next.loadNamespaces(locales.namespaces.rightholder, res);
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        viewerSet(response.payload);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })
            .catch(function () {
            setSubmitting(false);
            setErrors({ unknown: true });
        });
    };
    return {
        submit: submit,
        username: { value: username, set: setUsername },
        password: { value: password, set: setPassword },
        rememberMe: { value: rememberMe, set: setRememberMe },
        errors: errors,
        isSubmitting: isSubmitting,
    };
};
